import { useContext } from "react";
import { ColorProvider } from "~components/common/Layout";

export const Organic = () => {
  const { color, productBackground } = useContext(ColorProvider);
  return (
    <svg
      width="61"
      height="60"
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="0.5" width="59" height="59" rx="29.5" fill="white" />
      <rect x="1" y="0.5" width="59" height="59" rx="29.5" stroke="#E2DFDF" />
      <circle
        cx="39.7832"
        cy="25.6484"
        r="5.77148"
        fill={productBackground || color}
      />
      <path
        d="M30.5 37.1267C30.8683 36.3793 31.3801 35.6396 32.08 34.9397C35.9961 31.2138 39.6848 31.6333 42.814 28.5638C43.3349 28.0528 44.2078 28.1376 44.4596 28.8225C45.4214 31.4396 46.7563 37.1202 42.4398 41.4366C38.1766 45.6999 30.5132 44.9497 30.5 44.9484"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.1862 28.5638C17.6652 28.0528 16.7923 28.1376 16.5405 28.8225C15.5787 31.4396 14.2438 37.1202 18.5603 41.4366C22.1307 45.007 28.0861 45.0611 29.9352 44.9836C30.2878 44.9689 30.5911 44.7536 30.7094 44.4211C31.2481 42.9067 32.4102 38.4299 28.9201 34.9397C25.004 31.2138 21.3154 31.6334 18.1862 28.5638Z"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M30.5 44.9492L37.5237 37.9256"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M30.5002 44.9492L23.4766 37.9256"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M31.1684 16.3808C30.8002 16.749 30.2033 16.749 29.8351 16.3808V16.3808C27.9943 14.54 25.0097 14.54 23.1688 16.3808C21.3279 18.2216 21.3279 21.2062 23.1688 23.0471L29.7946 29.673C30.1851 30.0635 30.8183 30.0635 31.2088 29.673L37.8347 23.0471C39.6756 21.2062 39.6756 18.2216 37.8347 16.3808C35.9938 14.54 33.0092 14.54 31.1684 16.3808V16.3808Z"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
